import { DayRange } from './dayRange';
import DateTimeService from '@/shared/services/dateTime';
import { BusinessHoursViewModel } from '../../models';
import { BusinessHoursOptions } from './businessHoursOptions';
export class BusinessHoursOption {
	public static fromViewModel(businessHours: BusinessHoursViewModel): BusinessHoursOption {
		return new BusinessHoursOption(
			BusinessHoursOptions.findDayRangeOption(
				businessHours.startDay,
				businessHours.endDay,
				businessHours.holidayId
			),
			!businessHours.closed,
			DateTimeService.minutesToTime(businessHours.startTime),
			DateTimeService.minutesToTime(businessHours.endTime)
		);
	}
	constructor(
		public day: DayRange,
		public open: boolean,
		public startTime?: string,
		public endTime?: string
	) {}
	public toViewModel(): BusinessHoursViewModel {
		const openingTimes = {
			startDay: this.day.startDay,
			endDay: this.day.endDay,
			holidayId: this.day.holidayId,
			closed: !this.open
		} as BusinessHoursViewModel;

		openingTimes.startTime = DateTimeService.getMinutes(this.startTime);
		openingTimes.endTime = DateTimeService.getMinutes(this.endTime);

		return openingTimes;
	}
}
